import { isPwaUrl } from "@lib/urlMatchUtility"

const parseProductCarouselData = (data, gaLabelData) => {
    if (data?.length > 0) {
        const listOfProducts = data?.map((product) => {
            return {
                available: product?.available === "true" ? true : false,
                imageUrl: product?.image,
                imageAlt: product?.name,
                header: product?.name,
                subText: product?.label,
                url: product?.url,
                rating: {
                    averageRating: product?.ratings?.average_rating
                        ? parseFloat(product?.ratings?.average_rating)
                        : null,
                    totalRatings: product?.ratings?.total_ratings
                        ? parseFloat(product?.ratings?.total_ratings)
                        : null,
                },
                deliveryDate: product?.eta,
                price: product?.prices?.mrp,
                discount: product?.prices?.discount,
                discountedPrice: product?.prices?.discounted_price,
                sale: {
                    validity: product?.sale?.validity,
                    displayText: product?.sale?.tag,
                },
                tag: {
                    label: product?.tag?.text || "",
                    backgroundColor: product?.tag?.bgColor,
                },
                skuId: product?.id,
                quantityCta: {
                    min: product?.quantity_info?.min,
                    max: product?.quantity_info?.max,
                    header: product.quantity_info?.know_more?.header,
                    label: product.quantity_info?.display_text,
                    description: product.quantity_info?.know_more?.description,
                    functionMap: "minQuantityFunctionMap",
                },
                addToCartCta: {
                    label: product?.cta?.text,
                    type: "secondary",
                    iconUrl: "",
                    pageSource: "",
                    quantity: product?.quantity_info?.selling_quantity,
                    addSuccessFunctionMap: "addSuccess",
                    deleteSuccessFunctionMap: "deleteSuccess",
                    addErrorFunctionMap: "addError",
                    updateSuccessFunctionMap: "updateQuantitySuccessMap",
                    responseType: "full",
                },
                gaLabel: {
                    ...gaLabelData,
                    entity_id: product.id,
                    entity_name: product.name,
                    entity_discounted_price: product.prices?.discounted_price || "",
                    entity_price: product.prices?.mrp || "",
                    quantity: product?.quantity_info?.selling_quantity,
                    sku_sponsored: !!(
                        (product.ad && Object.keys(product.ad).length > 0) ||
                        product.os_attrs?.uclid
                    ),
                    manufacturerId: product?.manufacturerId,
                    uclid: product?.os_attrs?.uclid,
                },
                gaData: product?.ga_data?.info,
            }
        })
        return listOfProducts
    } else return []
}

export const parseCartRecommendation = (widgetsData) => {
    if (widgetsData?.length > 0) {
        const listOfCarousels = widgetsData?.map((widgetData) => {
            const type = widgetData.type
            switch (type) {
                case "upsell_products": {
                    const gaLabelData = {
                        widget_name: widgetData?.data?.header,
                        entity_type: widgetData?.type === "upsell_products" ? "sku" : "",
                        entity_sub_type: widgetData?.data?.sub_type || "",
                        ...(widgetData?.data?.gaData || {}),
                        widget_sponsored:
                            widgetData?.type === "upsell_products"
                                ? widgetData?.data?.gaData?.isSponsored
                                : false,
                    }
                    const data = {
                        variantSmall: true,
                        header: widgetData?.data?.header,
                        tag: {
                            label: widgetData?.data?.header_tag?.text,
                            color: widgetData?.data?.header_tag?.text_color,
                            backgroundColor: widgetData?.data?.header_tag?.bg_color,
                            borderColor: widgetData?.data?.header_tag?.border_color,
                        },
                        subText: widgetData?.data?.sub_header,
                        isSponsoredWidget: gaLabelData?.widget_sponsored || false,
                        productsData: parseProductCarouselData(widgetData?.data?.data, gaLabelData),
                    }
                    const widget = { data: data, type: widgetData.type }
                    return widget
                }

                case "list_of_test_carousel": {
                    if (widgetData.data) {
                        const data = {
                            heading: widgetData.data?.header,
                            subHeading: widgetData.data?.subHeader,
                            showMoreLabel: widgetData.data?.cta?.text,
                            redirectUrl: widgetData.data?.cta?.details?.targetUrl,
                            items: widgetData.data?.data?.map((result) => ({
                                id: result.id,
                                name: result.header,
                                subHeading: result.line1,
                                acronym: result.line2,
                                price: result.price?.mrp,
                                suffix: result.price?.priceSuffix,
                                discountedPrice: result.price?.discountedPrice,
                                discountPercent: result.price?.discount,
                                label: result.cta?.text,
                                imageUrl: result.image?.url,
                                altText: result.image?.alt,
                                slug: result.url,
                                isExternal: !isPwaUrl(result.url),
                                category: result.category,
                                subCategory: widgetData.header,
                                gaMetaData: { gaCategory: "Diagnostics Cart", page: "cart" },
                                buttonType: "secondary",
                                payload: {
                                    skus: [{ test_id: result.id }],
                                },
                                responseType: "full",
                                types: "labs",
                                addSuccessFunctionMap: "addLabsSuccess",
                                deleteSuccessFunctionMap: "deleteLabsSuccess",
                                addErrorFunctionMap: "addLabsError",
                                mixPanelData: result?.analytics_data_mixpanel,
                            })),
                            exprimentData: {
                                label: widgetData.experiment?.label,
                                status: widgetData.experiment?.status,
                                dataAvailable: widgetData.experiment?.data_available,
                                category: widgetData.experiment?.category,
                            },
                        }
                        const widget = {
                            data: data,
                            type: widgetData.type,
                        }
                        return widget
                    }
                }
            }
        })
        return listOfCarousels
    } else return []
}
export const parseCarePlanUpsellData = (data) => {
    if (data)
        return {
            header: data?.header,
            imageUrl: data?.icon,
            displayText: data?.display_text,
            planDetails:
                data?.plan_details && Object.keys(data?.plan_details).length > 0
                    ? {
                          header: data?.plan_details?.header,
                          subHeader: data?.plan_details?.sub_header,
                          priceDetails: {
                              price: data?.plan_details?.prices?.mrp,
                              discount: data?.plan_details?.prices?.discount,
                              discountedPrice: data?.plan_details?.prices?.discounted_price,
                          },
                          cta: {
                              label: data?.plan_details?.cta?.text,
                              url: data?.plan_details?.cta?.details?.target_url,
                              functionMap: "carePlanInfoDialog",
                          },
                      }
                    : {},
            benefits: data?.benefits?.map((benefit) => {
                return {
                    icon: benefit?.icon,
                    displayText: benefit?.display_text,
                }
            }),
            addToCart: {
                label: data?.primary_cta?.text,
                payload: {
                    skus: [
                        {
                            quantity: data?.primary_cta?.details?.quantity,
                            sku_id: data?.primary_cta?.details?.sku_id,
                        },
                    ],
                    page_source: "cart",
                },
                responseType: "full",
            },
            secondaryCta: {
                label: data?.secondary_cta.text,
            },
        }
    else return null
}
const getParsedPriceBreakups = (priceBreakups) => {
    const breakUps = []

    priceBreakups?.forEach((priceBreakUp) => {
        const breakUpObj = {
            header: priceBreakUp.display_text,
            originalPrice: priceBreakUp.price?.text,
            subHeader: priceBreakUp.sub_text,
            image: {
                url: priceBreakUp.info?.icon,
                altText: "price breakup",
                functionMap: priceBreakUp.info?.action,
                info: {
                    ...priceBreakUp.info?.data,
                    breakup: getParsedPriceBreakups(priceBreakUp.info?.data?.breakup),
                    header: priceBreakUp.info?.header,
                },
            },
            tag: {
                cta: { ...priceBreakUp?.tag?.cta },
                bgColor: priceBreakUp?.tag?.bg_color,
                text: priceBreakUp?.tag?.text,
                icon: priceBreakUp?.tag?.icon,
            },
            underlinedText: {
                text: priceBreakUp.underline_text_cta?.label,
                functionMap: priceBreakUp.underline_text_cta?.action,
            },
        }

        breakUps.push(breakUpObj)
    })

    return breakUps
}

export const parsingListOfItems = (data, doneInOne) => {
    return data?.map((product) => {
        return {
            imageUrl: product.icon,
            header: product.header,
            subHeader: product.sub_header,
            ctaLabel: product.cta?.text,
            quantity: product.cta?.details.quantity,
            minQuantityCta: product.quantity_info?.display_text,
            minQuantity: product.quantity_info?.min,
            minQuantityHeader: product.quantity_info?.know_more.header,
            minQuantityDescription: product.quantity_info?.know_more.description,
            minQuantityFunctionMap: "minQuantityFunctionMap",
            secondaryActionFunctionMap: "secondaryActionFunctionMap",
            tertiaryActionFunctionMap: doneInOne
                ? "tertiaryActionDoneInOneFunctionMap"
                : "tertiaryActionFunctionMap",
            primaryActionFunctionMap: doneInOne
                ? "primaryActionDoneInOneFunctionMap"
                : "primaryActionFunctionMap",
            maxQuantity: product.quantity_info?.max,
            payload: {
                skus: [
                    {
                        quantity: product.cta?.details.quantity,
                        sku_id: product.cta?.details?.sku_id || product.sku_id,
                    },
                ],
            },
            types: doneInOne ? "done_in_one" : "pharmacy",
            responseType: "full",
            price: product?.prices?.mrp,
            discountedPrice: product?.prices?.discounted_price,
            discount: product?.prices?.discount,
            skuId: product?.cta?.details?.sku_id || product.sku_id,
            tag: {
                label: product?.tag?.text,
                backgroundColor: product?.tag?.bg_color,
                color: product?.tag?.text_color,
                borderColor: product?.tag?.border_color,
            },
            isAvailable: product.is_available,
            secondaryCtaLabel: product?.secondart_cta?.text,
            tertiaryCtaLabel: "Remove",
            productType: product.product_type,
            url: doneInOne ? null : product.url,
            manufacturerId: product.manufacturer?.id || "",
            updateQuantitySuccessMap: doneInOne ? "" : "updateQuantitySuccessMap",
            updateQuantityErrorMap: doneInOne ? "" : "updateQuantityErrorMap",
            deleteQuantitySuccessMap: doneInOne
                ? "deleteQuantityDoneInOneSuccessMap"
                : "deleteQuantitySuccessMap",
            deleteQuantityErrorMap: doneInOne ? "" : "deleteQuantityErrorMap",
            analyticsData: product.analytics_data,
        }
    })
}

const parseHiddenListOfTestItems = (data, limit) => {
    let hiddenListOfTest = []
    data?.forEach((item, index) => {
        if (index >= limit) {
            hiddenListOfTest.push({
                id: item?.sku_id,
                skuCategory: item.cart_category || "",
                image: {
                    imageUrl: item.image?.url,
                    altText: item.image?.alt,
                },
                header: item.header,
                productType: null,
                discountPercent: item.prices?.discount,
                discountedPrice: item.prices?.discounted_price,
                price: item.prices?.mrp || "",
                description: item?.info,
                icon: {
                    iconUrl: item.delete_icon?.url,
                    altText: item.delete_icon?.alt,
                },
                tag: {
                    label: item.tag?.text,
                    borderColor: item.tag?.border_color,
                    color: item?.tag?.text_color,
                    backgroundColor: item.tag?.bg_color,
                },
                priceText: null,
                subText: null,
                url: item?.url,
                isAvailable: item?.is_available,
                informationDetails: item?.patients_data?.display_text,
                patientDetails: {
                    header: item.patients_data?.details?.header,
                    description: item.patients_data?.details?.description,
                    confirmCta: item.patients_data?.details?.confirm_cta?.text,
                },
            })
        }
    })
    return hiddenListOfTest
}

export const parseDialogBoxData = (widgets) => {
    let labDetailsBottomSheetData = {}
    widgets?.length > 0 &&
        widgets.forEach((item) => {
            switch (item?.type) {
                case "basic_details": {
                    labDetailsBottomSheetData.labTestDescriptionProps = {
                        type: item?.type,
                        title: item?.data?.title,
                        image: {
                            url: item?.data?.image?.url,
                            altText: item?.data?.image?.alt,
                        },
                    }
                    break
                }
                case "rating_widget": {
                    labDetailsBottomSheetData.ratingsOverviewProps = {
                        etaTextData: item?.data?.certificate?.header
                            ? {
                                  text: item?.data?.certificate?.header,
                                  imageUrl: item?.data?.certificate?.image?.url,
                                  imageAltText: item?.data?.certificate?.image?.alt,
                              }
                            : null,
                    }
                    break
                }
                case "general_description": {
                    labDetailsBottomSheetData.generalDescriptionProps = {
                        type: item?.type,
                        header: item?.data?.header,
                        content: item?.data?.display_text,
                    }
                    break
                }
            }
        })
    return labDetailsBottomSheetData
}
/**
 * parsing each test Items of cart and unavailable items page for list of test widget
 * @param {object} data
 * @return {Array} ListOfTestInCart
 */

export const parsingListOfTestItems = (data, limit) => {
    const count = limit || data?.length
    let listOfTest = []
    data?.forEach((item, index) => {
        if (index < count) {
            listOfTest.push({
                id: item.sku_id || item.test_id, // due to inconsistency in prod/env response
                skuCategory: item.cart_category || "",
                image: {
                    imageUrl: item.image?.url,
                    altText: item.image?.alt,
                },
                header: item.header,
                productType: null,
                discountPercent: item.prices?.discount,
                discountedPrice: item.prices?.discounted_price,
                price: item.prices?.mrp || "",
                description: item?.info,
                icon: {
                    iconUrl: item.delete_icon?.url,
                    altText: item.delete_icon?.alt,
                },
                tag: {
                    label: item.tag?.text,
                    borderColor: item.tag?.border_color,
                    color: item?.tag?.text_color,
                    backgroundColor: item.tag?.bg_color,
                },
                priceText: null,
                subText: null,
                url: item?.url,
                isAvailable: item?.is_available,
                informationDetails: item?.patients_data?.display_text,
                patientDetails: {
                    header: item.patients_data?.details?.header,
                    description: item.patients_data?.details?.description,
                    confirmCta: item.patients_data?.details?.confirm_cta?.text,
                },
                mixPanelData: item?.analytics_data_mixpanel,
            })
        }
    })
    return listOfTest
}

export const parseWidgetData = (data) => {
    let widgets = data?.widgets
    let widgetData = {}

    if (data?.action_button?.cta?.text) {
        widgetData["checkoutButton"] = {
            label: data?.action_button?.cta?.text,
            buttonType: "primary",
            functionMap: data?.action_button?.cta?.action,
            redirectUrl: data?.action_button?.cta?.target_url,
        }
    }
    if (data?.address_selection) {
        widgetData["addressSelectionWidget"] = {
            header: data?.address_selection?.header,
            addressName: data?.address_selection?.address_name,
            address: `${data?.address_selection?.street1 ? data?.address_selection?.street1 + ", " : ""}${
                data?.address_selection?.street2 ? data?.address_selection?.street2 + ", " : ""
            }${
                data?.address_selection?.city && data?.address_selection?.street1
                    ? decodeURI(data?.address_selection?.city) + ", "
                    : decodeURI(data?.address_selection?.city)
            }${data?.address_selection?.locality ? data?.address_selection?.locality + ", " : ""}${
                data?.address_selection?.state
            }${data?.address_selection?.pincode ? " (" + data?.address_selection?.pincode + ")" : ""}`,
            ctaLabel: data?.address_selection?.cta?.text,
            redirectUrl: data?.address_selection?.cta?.target_url,
            icon: data?.address_selection?.icon,
            geodataUpdateRequired: data?.address_selection?.is_geodata_update_required,
            id: data?.address_selection?.id,
            city: data?.address_selection?.city,
            pincode: data?.address_selection?.pincode ?? "",
        }
    }
    widgets.forEach((widget) => {
        switch (widget.type) {
            case "bill_summary": {
                widgetData["billSummaryWidget"] = {
                    header: widget.data.header,
                    priceBreakUp: getParsedPriceBreakups(widget.data.price_breakups),
                    paymentDetails: {
                        label: widget.data.label,
                        value: widget.data.payable_amount,
                    },
                }

                break
            }
            case "cart_items": {
                widgetData["listOfItemsOnCart"] =
                    widget.data.grouped_items?.length > 0
                        ? {
                              header: widget.data.header,
                              subHeader: widget.data.sub_header,
                              groupItems: widget.data.grouped_items?.map((item) => {
                                  return {
                                      header: item.display_text,
                                      itemInCart: parsingListOfItems(item?.items),
                                      infoIcon: { icon: item?.info?.icon, alt: "infoIcon" },
                                      infoData: item?.info?.data?.widgets.map((infoItem) => {
                                          return {
                                              header: infoItem?.data?.header,
                                              subHeader: infoItem?.data?.sub_header,
                                              steps: infoItem?.data?.values.map((item) => {
                                                  return {
                                                      header: item.header,
                                                      subHeader: item.display_text,
                                                      imageUrl: item.icon,
                                                  }
                                              }),
                                          }
                                      }),
                                  }
                              }),
                          }
                        : {}
                break
            }
            case "footnotes": {
                widgetData["footnotes"] = {
                    data: [
                        {
                            header: "",
                            displayText: widget.data.display_text,
                        },
                    ],
                }
                break
            }
            case "apply_coupon": {
                if (widget?.data?.cod_benefit) {
                    widgetData["carePlanCODBenefit"] = {
                        ...widget?.data?.cod_benefit,
                    }
                }
                if (widget?.data?.care_plan?.benefits?.display_text) {
                    widgetData["discountBreakUp"] = {
                        imageUrl: widget?.data?.care_plan?.icon,
                        header: widget?.data?.care_plan?.benefits?.display_text,
                        subHeader: widget?.data?.care_plan?.benefits?.savings,
                        breakUpsList: widget?.data?.care_plan?.benefits?.discount_breakups?.map(
                            (discount) => {
                                return { label: discount?.display_text, value: discount?.savings }
                            }
                        ),
                        cta: {
                            label: widget?.data?.care_plan?.cta?.text,
                            functionMap: "removeCarePlan",
                            couponCode: widget?.data?.care_plan?.benefits?.secondary_cta?.details?.sku_id,
                        },
                    }
                } else if (
                    widget?.data?.care_plan?.cta?.text === "Apply" &&
                    widget?.data?.care_plan?.benefits === null
                ) {
                    widgetData["discountBreakUp"] = {
                        imageUrl: widget?.data?.care_plan?.icon,
                        title: widget?.data?.care_plan?.display_text,
                        cta: {
                            label: widget?.data?.care_plan?.cta?.text,
                            functionMap: "applyCarePlan",
                            couponCode: widget?.data?.care_plan?.cta?.details?.coupon_code,
                        },
                    }
                } else if (
                    widget?.data?.care_plan?.cta?.text === "Applied" &&
                    widget?.data?.care_plan?.benefits === null
                ) {
                    widgetData["discountBreakUp"] = {
                        imageUrl: widget?.data?.care_plan?.icon,
                        title: widget?.data?.care_plan?.display_text,
                        cta: {
                            label: widget?.data?.care_plan?.cta?.text,
                            functionMap: "removeCarePlan",

                            couponCode: widget?.data?.care_plan?.cta?.details?.coupon_code,
                        },
                    }
                }
                if (widget?.data?.coupon) {
                    widgetData["applyCoupon"] = {
                        couponApplied: widget?.data?.coupon?.is_coupon_applied,
                        appliedCouponCode: widget?.data?.coupon?.coupon_code,
                        subtext: widget?.data?.coupon?.header
                            ? widget?.data?.coupon?.header
                            : widget?.data?.coupon?.display_text,
                        couponDownChevronIcon: widget?.data?.coupon?.benefits?.header?.text
                            ? widget?.data?.coupon?.info_icon
                            : null,
                        dialogData: {
                            icon: widget?.data?.coupon?.benefits?.header?.icon,
                            header: widget?.data?.coupon?.benefits?.header?.text,
                            displayText: widget?.data?.coupon?.benefits?.display_text,
                            highlightedText: widget?.data?.coupon?.benefits?.savings,
                            breakUpsList: widget?.data?.coupon?.benefits?.discount_breakups?.map(
                                (discount, index) => {
                                    return {
                                        label: discount?.display_text,
                                        value: discount?.savings,
                                        showVerticalSeperator:
                                            Object.keys(widget?.data?.coupon?.benefits?.discount_breakups)
                                                ?.length > 1 &&
                                            index !==
                                                Object.keys(widget?.data?.coupon?.benefits?.discount_breakups)
                                                    ?.length -
                                                    1,
                                    }
                                }
                            ),
                            col: widget?.data?.coupon?.benefits?.column,
                            primaryAction: {
                                label: widget?.data?.coupon?.benefits?.primary_cta?.text,
                                functionMap: widget?.data?.coupon?.benefits?.primary_cta?.action,
                            },
                            secondaryAction: {
                                label: widget?.data?.coupon?.benefits?.secondary_cta?.text,
                                functionMap: widget?.data?.coupon?.benefits?.secondary_cta?.action,
                            },
                        },
                    }
                }
                break
            }
            case "tcp_points_details": {
                widgetData["tcpPoints"] = {
                    header: widget?.data?.redeem?.title,
                    availed: widget?.data?.redeem?.availed,
                    headerIcon: widget?.data?.redeem?.logo,
                    secondaryText: widget?.data?.redeem?.sub_title,
                    checkBoxMessage: widget?.data?.redeem?.redeemable_message,
                    redeemablePoints: widget?.data?.redeem?.balance,
                    earnedInfo: {
                        text: widget?.data?.earn?.earn_message_1,
                        subText: widget?.data?.earn?.earn_message_2,
                    },
                    carePlan: {
                        user: {
                            cpUser: widget?.data?.earn?.care_plan?.cp_user ? true : false,
                            text: widget?.data?.earn?.care_plan?.cp_user
                                ? widget?.data?.earn?.care_plan?.cp_user?.text
                                : widget?.data?.earn?.care_plan?.non_cp_user?.text,
                            icon: widget?.data?.earn?.care_plan?.cp_user
                                ? widget?.data?.earn?.care_plan?.cp_user?.logo
                                : widget?.data?.earn?.care_plan?.non_cp_user?.icon,
                            functionMap: "carePlanInfoDialog",
                            infoIcon: widget?.data?.earn?.care_plan?.cp_user
                                ? null
                                : widget?.data?.earn?.care_plan?.non_cp_user?.help?.icon,
                            targetUrl: widget?.data?.earn?.care_plan?.cp_user
                                ? null
                                : widget?.data?.earn?.care_plan?.non_cp_user?.help?.target,
                            toolTipText: widget?.data?.earn?.care_plan?.non_cp_user?.help?.text,
                        },
                        upsell: {
                            buttonType: "textual",
                            payload: {
                                skus: [
                                    {
                                        quantity:
                                            widget?.data?.earn?.care_plan?.upsell?.cta?.details?.quantity,
                                        sku_id: widget?.data?.earn?.care_plan?.upsell?.cta?.details?.sku_id,
                                    },
                                ],
                                page_source: "cart",
                            },
                            label: widget?.data?.earn?.care_plan?.upsell?.cta?.text,
                            responseType: "full",
                        },
                        statusInfo: {
                            text: widget?.data?.earn?.care_plan?.cp_status_info?.text,
                            icon: widget?.data?.earn?.care_plan?.cp_status_info?.icon,
                        },
                    },
                    ctaLabel: widget.data?.redeem?.neucoin_edit_cta?.cta_label,
                    applyCtaLabel: widget.data?.redeem?.neucoin_edit_widget?.cta?.label,
                    firstHeading: widget.data?.redeem?.neucoin_edit_widget?.heading,
                    secondHeading: widget.data?.redeem?.neucoin_edit_widget?.neucoins_data?.heading,
                    iconUrl: widget.data?.redeem?.neucoin_edit_widget?.neucoins_data?.icon,
                    maxRedeemableTcpPoints:
                        widget.data?.redeem?.neucoin_edit_widget?.neucoins_data?.max_redeemable_tcp_points,
                    secondSubHeading: widget.data?.redeem?.neucoin_edit_widget?.neucoins_data?.sub_heading,
                    boxDescription: widget.data?.redeem?.neucoin_edit_widget?.description,
                    emptyMsg: widget.data?.redeem?.neucoin_edit_widget?.validator_msg?.empty,
                    exceedingAmountToBePaidMsg:
                        widget.data?.redeem?.neucoin_edit_widget?.validator_msg?.exceeding_amount_to_be_paid,
                    exceedingBalanceMsg:
                        widget.data?.redeem?.neucoin_edit_widget?.validator_msg?.exceeding_balance,
                    negativeAmountMsg:
                        widget.data?.redeem?.neucoin_edit_widget?.validator_msg?.negative_amount,
                    redeemableMessage:
                        widget.data?.redeem?.redeemable_amount > 0 && widget.data.redeem.redeemable_message,
                    redeemableAmount: widget.data?.redeem?.redeemable_amount,
                }
                break
            }
            case "care_plan_expiration": {
                widgetData["carePlanExpirationTimer"] = {
                    header: widget?.data?.header,
                    subHeader: widget?.data?.sub_header,
                    benefits: widget?.data?.benefits,
                    icon: widget?.data?.icon,
                    carePlanIconUrl: widget?.data?.image_url,
                    displayText: widget?.data?.display_text,
                    prices: {
                        price: widget?.data?.prices?.mrp,
                        discountedPrice: widget?.data?.prices?.discounted_price,
                        discount: widget?.data?.prices?.discount,
                    },
                    addToCart: {
                        label: widget?.data?.cta?.text,
                        payload: {
                            skus: [
                                {
                                    quantity: widget?.data?.cta?.details?.quantity,
                                    sku_id: widget?.data?.cta?.details?.sku_id,
                                },
                            ],
                        },
                        addSuccessFunctionMap: "renewCareplanSuccessViaCareplanExpirationTimer",
                        addErrorFunctionMap: "renewCareplanErrorViaCareplanExpirationTimer",
                        responseType: "full",
                    },
                    revisedPlanInfo: {
                        text: widget?.data?.revised_plan_info?.text,
                        functionMap: "carePlanInfoDialog",
                        info: {
                            icon: widget?.data?.revised_plan_info?.info?.icon,
                        },
                        dialogData: parseCarePlanUpsellData(widget?.data?.revised_plan_info?.bottomsheet),
                    },
                }
                break
            }
            case "done_in_one_temp_cart_items": {
                widgetData["doneInOneWidget"] = {
                    heading: widget?.data?.header,
                    subHeading: widget?.data?.sub_header,
                    primaryCta: {
                        label: widget?.data?.primary_cta?.text,
                        functionMap: "addToCartDoneInOne",
                    },
                    secondaryCta: {
                        label: widget?.data?.cta?.text,
                        functionMap: "seeAllItemsDoneInOne",
                    },
                    productArray: widget?.data?.skus?.map((sku) => {
                        return {
                            name: sku?.name,
                            imageUrl: sku?.image,
                            eta: sku?.label,
                            redirectUrl: sku?.url,
                        }
                    }),
                }
                break
            }
            case "highlighted_info": {
                widgetData["highlightedImage"] = {
                    icon: widget?.data?.icon,
                }
                break
            }
            case "textual_nudge": {
                widgetData["textualNudge"] = {
                    imageUrl: widget?.data?.icon,
                    description: widget?.data?.display_text,
                }
                break
            }
            case "list_tests_cart": {
                const items = widget.data?.items ? widget.data?.items : widget?.data?.grouped_items[0]?.items

                widgetData["listOfTestOnCart"] = {
                    header: widget.data?.header,
                    subHeader: widget.data?.sub_header,
                    isOnemgLab: widget.data?.is_onemg_lab,
                    listOfItems: parsingListOfTestItems(items, widget.data?.up_front_count),
                    hiddenListOfTest: widget.data?.up_front_count
                        ? parseHiddenListOfTestItems(items, widget.data?.up_front_count)
                        : [],
                    linkText: widget.data?.cta?.text,
                    labItems: {
                        labId: widget.data?.lab?.id,
                        url: widget.data?.lab?.url,
                        imageUrl: widget.data?.lab?.image?.url,
                        altText: widget.data?.lab?.image?.alt,
                        header: widget.data?.lab?.header,
                        subHeader: widget.data?.lab?.sub_header,
                        ctaLabel: widget.data?.lab?.cta?.text,
                        changeLabsUrl: widget.data?.lab?.cta?.details?.target_url,
                    },
                    footerData: {
                        label: widget.data?.footer?.label,
                        labIcon: widget.data?.footer?.lab_icon?.url,
                        labAltText: widget.data?.footer?.lab_icon?.alt,
                        infoIconData: {
                            infoIconUrl: widget.data?.footer?.info_icon?.url,
                            infoIconAlt: widget.data?.footer?.info_icon?.alt,
                        },
                    },
                    dialogBoxData: {
                        header: widget.data?.footer?.lab_details_bottomsheet?.heading,
                        ...parseDialogBoxData(widget.data?.footer?.lab_details_bottomsheet?.data),
                    },
                }
                break
            }
            case "checkbox_upsell": {
                widgetData["checkboxUpsell"] = {
                    header: widget.data?.header,
                    checkboxLabel: widget.data.sub_header,
                    isChecked: widget.data?.is_checked,
                    description: widget.data?.display_text,
                    identifier: widget.data?.identifier,
                }
                break
            }
            case "vas_nudge": {
                const parseVasList = (data) => {
                    return data.map((vas) => {
                        return {
                            image: {
                                url: vas.vas_image,
                            },
                            header: vas.title,
                            subHeader: vas.description,
                            id: vas.vas_identifier,
                            info: vas?.vas_info_details
                                ? {
                                      image: {
                                          url: vas.info_icon_url || "",
                                      },
                                      data: vas.vas_info_details.data
                                          ? {
                                                ...vas.vas_info_details.data,
                                                subHeader: vas.vas_info_details.data?.sub_header,
                                            }
                                          : {},
                                      type: vas.vas_info_details.type || "",
                                  }
                                : null,
                            isSelected: !!vas.is_selected,
                            price: vas?.pricing
                                ? {
                                      pricePrefix: vas.pricing.price_prefix || "",
                                      priceSuffix: vas.pricing.price_suffix || "",
                                      mrp: vas.pricing.mrp || "",
                                      discountedPrice: vas.pricing.discounted_price || "",
                                      discountPercent: vas.pricing.discount || "",
                                  }
                                : null,
                        }
                    })
                }
                widgetData["vasNudge"] = {
                    header: widget.data?.header,
                    subHeader: widget.data?.sub_header || "",
                    vasList: parseVasList(widget.data?.vas_list),
                }
                break
            }
            case "insurance_plan": {
                if (widget?.data) {
                    widgetData["insurancePlan"] = {
                        mixPanelData: widget.data?.mix_panel_data,
                        bgImage: {
                            url: widget.data?.bg_image?.url,
                            alt: widget.data?.bg_image?.alt,
                            resolution: widget.data?.bg_image?.resolution,
                        },
                        header: widget.data?.header,
                        headerImage: {
                            url: widget.data?.header_image?.url,
                            alt: widget.data?.header_image?.alt,
                            resolution: widget.data?.header_image?.resolution,
                        },
                        data: widget.data?.data.map((item) => ({
                            icon: item?.icon,
                            text: item?.text,
                            subText: item?.sub_text,
                        })),
                        footer: {
                            bgColor: widget.data?.footer?.bg_color,
                            text: widget.data?.footer?.text,
                            cta: {
                                action: widget.data?.footer.cta?.action,
                                text: widget.data?.footer?.cta?.text,
                                details: {
                                    skuId: widget.data?.footer?.cta?.details?.sku_id,
                                    quantity: widget.data?.footer?.cta?.details?.quantity,
                                    mixPanelData: widget.data?.footer?.cta.details?.mix_panel_data,
                                },
                            },
                        },
                        bgBorder: widget.data?.bg_border,
                    }
                }
                break
            }
        }
    })

    return widgetData
}

export const parseCouponData = (listOfWidgets) => {
    const widgets = []

    listOfWidgets.forEach((widget) => {
        if (widget.type === "coupons") {
            const widgetData = {
                heading: widget.data.header,
                subHeading: widget.data.sub_header,
                list: getFormattedCouponList(widget.data.coupons),
            }

            widget.data.coupons.length && widgets.push(widgetData)
        }
    })

    return widgets
}

const getFormattedCouponList = (list) => {
    let couponList = []
    list.forEach((element) => {
        const coupon = {
            heading: element.header,
            subHeading: element.sub_header,
            disclaimer: element.discount,
            couponCode: element.coupon_code,
            couponDetails: {
                details: element.terms_conditions?.info,
                title: "Coupon details",
            },
            termsAndConditionsCta: {
                label: element.terms_conditions?.text,
                target: element.terms_conditions?.target,
                info: element.terms_conditions?.info,
                action: element.terms_conditions?.action,
            },
            applyCouponCta: {
                isEnabled: element.cta?.action === "APPLY_COUPON" ? true : false,
                label: element.cta?.text || "",
            },
            imageUrl: element.icon,
        }

        couponList.push(coupon)
    })

    return couponList
}

export const parseDoneInOneWidgets = (data) => {
    let widgets = data?.widgets
    let widgetData = {}

    widgets.forEach((widget) => {
        switch (widget.type) {
            case "cart_items": {
                widgetData["listOfItemsOnCart"] = {
                    header: widget.data.header,
                    subHeader: widget.data.sub_header,
                    groupItems: widget.data.grouped_items?.map((item) => {
                        return {
                            header: item.display_text,
                            itemInCart: parsingListOfItems(item?.items, true),
                            infoData: item?.info?.data.widgets.map((infoItem) => {
                                return {
                                    heading: infoItem?.data.header,
                                    subHeading: infoItem?.data.sub_header,
                                    steps: infoItem?.data.values.map((item) => {
                                        return {
                                            heading: item.header,
                                            subHeading: item.display_text,
                                            imageUrl: item.icon,
                                        }
                                    }),
                                }
                            }),
                        }
                    }),
                }
                break
            }
            case "highlighted_info": {
                widgetData["highlightedImage"] = {
                    icon: widget?.data?.icon,
                }
                break
            }
        }
    })

    return widgetData
}

/**
 * Creating parsed data for addressSelection for which this function is called
 * @param {object} data
 * @return {object} updateAddressDialogBox with it's type and data
 */
export const parseUpdateAddressData = (data) => {
    let updateAddressDialogBox = {
        description: data?.description,
        header: data?.header,
        icon: data?.icon,
        primaryCta: data?.primary_cta?.text,
        secondaryCta: data?.secondary_cta?.text,
    }

    return updateAddressDialogBox
}
export const parseCheckoutWidgets = (data) => {
    let widgets = data?.widgets
    let widgetData = {}
    if (widgets) {
        widgets.forEach((widget) => {
            switch (widget.type) {
                case "oos_items": {
                    widgetData["header"] = {
                        text: widget.data.header,
                    }
                    widgetData["actionButton"] = {
                        label: widget.data.cta?.text,
                        payload: {
                            cartId: widget.data.cta?.details?.cart_id,
                            sku_ids: widget.data.items.map((item) => {
                                return item?.sku_id
                            }),
                            page_source: "cart",
                            response_type: "full",
                            types: "pharmacy",
                        },
                    }
                    widgetData["listOfItemsOnCart"] = {
                        groupItems: [
                            {
                                itemInCart: widget.data.items.map((item) => {
                                    return {
                                        imageUrl: item?.icon,
                                        header: item?.header,
                                        price: item?.prices?.mrp,
                                        discount: item?.prices?.discount,
                                        discountedPrice: item?.prices?.discounted_price,
                                        subHeader: item?.sub_header,
                                        tag: {
                                            label: item?.tag?.text,
                                            backgroundColor: item?.tag?.bg_color,
                                            color: item?.tag?.text_color,
                                        },
                                        skuId: item?.sku_id,
                                    }
                                }),
                            },
                        ],
                    }
                }
            }
        })
    }

    return widgetData
}

export const parseLabsCheckoutWidgets = (data) => {
    let widgets = data?.widgets
    let widgetData = {}
    if (widgets) {
        widgets.forEach((widget) => {
            switch (widget.type) {
                case "oos_items": {
                    widgetData["header"] = {
                        text: widget.data.header,
                    }
                    widgetData["actionButton"] = {
                        label: widget.data.cta?.text,
                        payload: {
                            cartId: widget.data.cta?.details?.cart_id,
                            sku_ids: widget.data.items?.map((item) => {
                                return { test_id: item?.sku_id || item?.test_id }
                            }),
                            response_type: "full",
                            types: "labs",
                        },
                    }
                    widgetData["listOfTestOnCart"] = { items: parsingListOfTestItems(widget.data.items) }
                }
            }
        })
    }
    return widgetData
}

export const parseInsuranceBottomSheet = (data) => {
    if (data) {
        return {
            bgImage: {
                url: data?.bg_image?.url,
                alt: data?.bg_image?.alt,
                resolution: data?.bg_image?.resolution,
            },
            headerImage: {
                url: data?.header_image?.url,
                alt: data?.header_image?.alt,
                resolution: data?.header_image?.resolution,
            },
            header: data?.header,
            benefits: data?.benefits?.map((benefit) => ({
                icon: benefit?.icon,
                text: benefit?.text,
                subText: benefit?.sub_text,
            })),
            mixPanelData: data?.mix_panel_data,
            primaryCta: {
                animation: data?.primary_cta?.anim,
                action: data?.primary_cta?.action,
                text: data?.primary_cta?.text,
                subText: data?.primary_cta?.sub_text,
                details: {
                    ctaText: data?.primary_cta?.details?.cta_text,
                    skuId: data?.primary_cta?.details?.sku_id,
                    quantity: data?.primary_cta?.details?.quantity,
                    mixPanelData: data?.primary_cta?.details?.mix_panel_data,
                },
            },
            secondaryCta: {
                action: data?.secondary_cta?.action,
                text: data?.secondary_cta?.text,
                details: {
                    ctaText: data?.secondary_cta?.details?.cta_text,
                    mixPanelData: data?.secondary_cta?.details?.mix_panel_data,
                },
            },
            confirmationBottomSheet: data?.confirmation_bottomsheet,
            note: data?.note,
        }
    }
}

export const getCartItemsWidget = (widgets) => {
    if (!widgets) return []
    const cartItemsWidgets = []

    widgets.forEach((widget) => {
        if (widget.type === "cart_items") {
            cartItemsWidgets.push(widget)
        }
    })
    return cartItemsWidgets
}

export function extractSkuIds(cartItemsWidgets) {
    if (!cartItemsWidgets) return []
    const skuIds = []

    cartItemsWidgets.forEach((widget) => {
        widget?.data?.grouped_items?.forEach((group) => {
            group?.items?.forEach((item) => {
                skuIds.push(item?.sku_id?.toString())
            })
        })
    })

    return skuIds
}
